module.exports = __webpack_public_path__ + "static/media/rene.0128532d.jpg";